import React, { type PropsWithChildren } from 'react';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightManager } from '@atlaskit/onboarding';
import { canMigrateToNewSpotlightPackage } from '../common/canMigrateToNewSpotlightPackage.tsx';

export const ConditionalSpotlightManager = ({ children }: PropsWithChildren): React.JSX.Element => {
	if (canMigrateToNewSpotlightPackage()) {
		return <>{children}</>;
	}
	return <SpotlightManager blanketIsTinted={false}>{children}</SpotlightManager>;
};
